"use strict";
var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var AbstractViewerController = require("./../../abstractViewerController.js");

var LogoInteractionView = require("./logoInteractionView.js");
var LogoInteractionModel = require("./logoInteractionModel.js");

var LogoViewerController = function(archLayers, dependencies, configuration) {
    AbstractViewerController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(LogoViewerController, AbstractViewerController);
LogoViewerController.inject = AbstractViewerController.inject;

module.exports = LogoViewerController;

LogoViewerController.prototype.beforeLoad = function () {
    AbstractViewerController.prototype.beforeLoad.call(this);
};

LogoViewerController.prototype.getDataType = function () {
    return cio_datamodel.LogoData;
};

LogoViewerController.prototype.getInteractionViewType = function () {
    return LogoInteractionView;
};

LogoViewerController.prototype.getInteractionModelType = function () {
    return LogoInteractionModel;
};
